import { HubImageSection } from 'utils/gloo-types';
import { ActionType } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/action';
import { HubAuthoringDispatchContext } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/reducer';
import { HubAuthoringFormErrors } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/types';
import { ChangeEvent, useContext } from 'react';
import { isVideo } from 'utils/discover';
import Input from 'components/molecules/Input';
import HubAuthoringHeaderMedia from './HubsAuthoringHeader/HubsAuthoringHeaderMedia';

interface HubSectionImageFormProps {
  index: number;
  section: HubImageSection & { clientId: string };
  errors: HubAuthoringFormErrors;
}

const HubSectionImageForm = ({ index, section, errors }: HubSectionImageFormProps) => {
  const dispatch = useContext(HubAuthoringDispatchContext);
  const sectionId = section.clientId;

  return (
    <div>
      <HubAuthoringHeaderMedia
        error={errors.sections[sectionId]?.imageUrl}
        required
        header="Media"
        className="-mt-6"
        previewWidth={700}
        existingImg={section.imageUrl}
        handleImgSelect={(imgUrl) => {
          dispatch({
            type: ActionType.setSectionImageUrl,
            payload: {
              index,
              imageUrl: imgUrl,
            },
          });
        }}
      />
      {!isVideo(section.linkUrl) && (
        <Input
          label="Destination URL (Optional)"
          placeholder="https://www.example.com"
          value={section.linkUrl}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: ActionType.setSectionLinkUrl,
              payload: {
                index,
                linkUrl: event.target.value,
              },
            });
          }}
        />
      )}
    </div>
  );
};

export default HubSectionImageForm;
